import { StyledComponentProps, Theme, withStyles } from '@material-ui/core/styles';
import { observer } from 'mobx-react';
import * as React from 'react';

const normalize = (price: number | undefined) => price && price>0 ? +price : 0;

const fmt = (price: number) => 'EUR ' + price.toFixed(3).replace('.', ',');

const styles = (theme: Theme) => ({
	listPrice: {
		color: '#444444',
		textDecoration: 'line-through #222222',
		fontSize: 14,
		marginBottom: 3,
	},
	loneListPrice: {
		color: '#222222',
	},
	retailPrice: {
		color: '#DD1212',
	},
});

interface IPricePairProps {
	entity: {
		listPrice?: number
		retailPrice?: number
	}
}

@observer class _PricePair extends React.Component<IPricePairProps & StyledComponentProps> {
	render() {
		const classes = this.props.classes || {};
		const {entity} = this.props;
		const listPrice = normalize(entity.listPrice);
		const retailPrice = normalize(entity.retailPrice);

		if (listPrice) {
			if (retailPrice) {
				return <div>
					<div className={classes.listPrice}>{fmt(listPrice)}</div>
					<div className={classes.retailPrice}>{fmt(retailPrice)}</div>
				</div>;
			} else {
				return <div className={classes.loneListPrice}>{fmt(listPrice)}</div>;
			}
		} else {
			if (retailPrice) {
				return <div className={classes.retailPrice}>{fmt(retailPrice)}</div>;
			} else {
				return null;
			}
		}
	}
}

export const PricePair = withStyles(styles)(_PricePair);
